import React, { useEffect, useState } from "react";
import {
  Box,
  Chip,
  Stack,
  Typography,
  Card,
  CardContent,
  Button,
  Fade,
  Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  PlayArrow,
  CheckCircle,
  Schedule,
  AccessTime,
  Quiz,
  CheckCircleOutline,
  Update,
  AllInclusive,
  PendingActions,
  Science,
  Assignment,
} from "@mui/icons-material";
import {
  StyledTabsV2,
  StyledTabV2,
  TabContainerV2,
} from "../../Common/UI/TabPanel";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import { theme } from "../../../theme";

const statusLabelMap: any = {
  pending: "Pending",
  not_started: "Not Started",
  completed: "Completed",
};

const statusTextColorMap: any = {
  pending: "#d97706",
  not_started: "#64748b",
  completed: "#059669",
};

const statusBgColorMap: any = {
  pending: "#fef3c7",
  not_started: "#f1f5f9",
  completed: "#d1fae5",
};

const statusIconMap: any = {
  pending: <Schedule />,
  not_started: <PlayArrow />,
  completed: <CheckCircle />,
};

const StudySurvey = () => {
  const [loading, setLoading] = useState(true);
  const [surveyPackages, setSurveyPackages] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedStudy, setSelectedStudy] = useState<string>("");
  const [studySelectionMode, setStudySelectionMode] = useState(true);
  const primaryColor = theme.palette.primary.main;
  // const studyId = localStorage.getItem("study-id") || "";
  const navigate = useNavigate();
  const [studies, setStudies] = useState<any[]>([]);

  // Mock studies data
  // const mockStudies = [
  //   {
  //     id: "study1",
  //     name: "Crohn's Disease Treatment Study",
  //     description: "Investigating new treatment approaches for Crohn's disease",
  //     participantCount: 1250,
  //     duration: "24 months",
  //     status: "active",
  //   },
  //   {
  //     id: "study2",
  //     name: "IBD Quality of Life Research",
  //     description:
  //       "Understanding the impact of IBD on daily life and well-being",
  //     participantCount: 890,
  //     duration: "18 months",
  //     status: "active",
  //   },
  //   {
  //     id: "study3",
  //     name: "Medication Adherence Study",
  //     description:
  //       "Evaluating factors affecting medication compliance in IBD patients",
  //     participantCount: 650,
  //     duration: "12 months",
  //     status: "active",
  //   },
  // ];

  // Mock surveys data for selected study
  // const getMockSurveys = (studyId: string) => {
  //   const surveysByStudy: any = {
  //     study1: [
  //       {
  //         id: "1",
  //         surveyPackageId: "pkg1",
  //         name: "Treatment Effectiveness Assessment",
  //         status: "not_started",
  //         description:
  //           "Evaluate the effectiveness of current treatment protocols",
  //         estimatedTime: "20-25 minutes",
  //         lastUpdated: "2024-01-15",
  //         totalQuestions: 52,
  //       },
  //       {
  //         id: "2",
  //         surveyPackageId: "pkg2",
  //         name: "Symptom Tracking Diary",
  //         status: "pending",
  //         description: "Daily symptom monitoring and severity assessment",
  //         estimatedTime: "5-10 minutes",
  //         lastUpdated: "2024-01-10",
  //         totalQuestions: 15,
  //       },
  //       {
  //         id: "3",
  //         surveyPackageId: "pkg3",
  //         name: "Treatment Side Effects Survey",
  //         status: "completed",
  //         description: "Document any side effects from current medications",
  //         estimatedTime: "15-20 minutes",
  //         lastUpdated: "2024-01-08",
  //         totalQuestions: 38,
  //         completedDate: "2024-01-12",
  //       },
  //     ],
  //     study2: [
  //       {
  //         id: "4",
  //         surveyPackageId: "pkg4",
  //         name: "Daily Life Impact Assessment",
  //         status: "not_started",
  //         description: "How IBD affects your daily activities and routines",
  //         estimatedTime: "25-30 minutes",
  //         lastUpdated: "2024-01-05",
  //         totalQuestions: 65,
  //       },
  //       {
  //         id: "5",
  //         surveyPackageId: "pkg5",
  //         name: "Social Life and Relationships Survey",
  //         status: "pending",
  //         description: "Impact of IBD on social interactions and relationships",
  //         estimatedTime: "18-22 minutes",
  //         lastUpdated: "2024-01-12",
  //         totalQuestions: 42,
  //       },
  //     ],
  //     study3: [
  //       {
  //         id: "6",
  //         surveyPackageId: "pkg6",
  //         name: "Medication Reminder Preferences",
  //         status: "not_started",
  //         description:
  //           "Understanding your preferred methods for medication reminders",
  //         estimatedTime: "12-15 minutes",
  //         lastUpdated: "2024-01-15",
  //         totalQuestions: 28,
  //       },
  //       {
  //         id: "7",
  //         surveyPackageId: "pkg7",
  //         name: "Barriers to Medication Adherence",
  //         status: "completed",
  //         description: "Identifying obstacles to consistent medication intake",
  //         estimatedTime: "20-25 minutes",
  //         lastUpdated: "2024-01-08",
  //         totalQuestions: 45,
  //         completedDate: "2024-01-10",
  //       },
  //     ],
  //   };
  //   return surveysByStudy[studyId] || [];
  // };

  useEffect(() => {
    const fetchStudies = async () => {
      try {
        setLoading(true);
        const url = `/participants/me/studies`;
        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data;
        setStudies(data || []);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
      }
    };

    fetchStudies();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const studyId = selectedStudy;
        const res: AxiosResponse = await http.get(
          `/participant-survey/list?studyId=${studyId}`
        );
        const formattedData = res.data?.data?.map((item: any) => ({
          id: item?.id,
          surveyPackageId: item?.package?.id,
          name: item?.package?.name || "",
          status:
            item?.status === "sent"
              ? item?.totalForms > 0
                ? "pending"
                : "not_started"
              : item?.status,
        }));
        setSurveyPackages(formattedData || []);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    if (selectedStudy) {
      fetchData();
    }
  }, [selectedStudy, setLoading]);

  const navigateToSurvey = (surveyId: string) => {
    navigate(`/participant/app/surveys/${selectedStudy}/package/${surveyId}`);
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "#059669";
      case "pending":
        return "#d97706";
      default:
        return "#64748b";
    }
  };

  const getStatusIcon = (status: string) => {
    return statusIconMap[status] || <PlayArrow />;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleStudySelect = (studyId: string) => {
    setSelectedStudy(studyId);
    setStudySelectionMode(false);
  };

  const handleBackToStudySelection = () => {
    setStudySelectionMode(true);
    setSelectedStudy("");
    setSurveyPackages([]);
    setActiveTab(0);
  };

  const getFilteredSurveys = () => {
    switch (activeTab) {
      case 0: // All Surveys
        return surveyPackages;
      case 1: // Not Started
        return surveyPackages.filter(
          (survey) => survey.status === "not_started"
        );
      case 2: // In Progress
        return surveyPackages.filter((survey) => survey.status === "pending");
      case 3: // Completed
        return surveyPackages.filter((survey) => survey.status === "completed");
      default:
        return surveyPackages;
    }
  };

  const getTabCounts = () => {
    return {
      all: surveyPackages.length,
      notStarted: surveyPackages.filter(
        (survey) => survey.status === "not_started"
      ).length,
      inProgress: surveyPackages.filter((survey) => survey.status === "pending")
        .length,
      completed: surveyPackages.filter(
        (survey) => survey.status === "completed"
      ).length,
    };
  };

  const getSelectedStudyInfo = () => {
    return studies?.find((study) => study.id === selectedStudy);
  };

  return (
    <Box
      sx={{
        width: "100%",
        p: { xs: 2, sm: 3, md: 4 },
        minHeight: "100vh",
      }}
    >
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            mb: 1,
            fontSize: { xs: "20px", sm: "22px", md: "24px" },
          }}
        >
          Study Specific Surveys
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#475569",
            fontSize: { xs: "14px", sm: "16px" },
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          Select a study to view and complete its specific research surveys
        </Typography>

        {/* Study Selection Mode */}
        {studySelectionMode ? (
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                mb: 3,
                fontSize: { xs: "18px", sm: "20px" },
              }}
            >
              Choose a Study
            </Typography>

            {/* Study List Loading State */}
            {loading ? (
              <Fade in={loading}>
                <Stack spacing={3}>
                  {[1, 2, 3].map((index) => (
                    <Card
                      key={index}
                      sx={{
                        borderRadius: "16px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                        border: "1px solid rgba(226, 232, 240, 0.6)",
                        background: "rgba(255, 255, 255, 0.9)",
                      }}
                    >
                      <CardContent sx={{ p: 3 }}>
                        <Stack spacing={2}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                              gap: 2,
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  mb: 1,
                                }}
                              >
                                <Skeleton
                                  variant="rectangular"
                                  width={48}
                                  height={48}
                                  sx={{ borderRadius: "12px" }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="70%"
                                  height={24}
                                  sx={{ borderRadius: "4px" }}
                                />
                              </Box>
                              <Skeleton
                                variant="text"
                                width="90%"
                                height={16}
                                sx={{ borderRadius: "4px", mb: 1 }}
                              />
                              <Skeleton
                                variant="text"
                                width="60%"
                                height={16}
                                sx={{ borderRadius: "4px", mb: 2 }}
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 3,
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                }}
                              >
                                <Skeleton
                                  variant="text"
                                  width={120}
                                  height={16}
                                  sx={{ borderRadius: "4px" }}
                                />
                                <Skeleton
                                  variant="text"
                                  width={80}
                                  height={16}
                                  sx={{ borderRadius: "4px" }}
                                />
                              </Box>
                            </Box>
                            <Skeleton
                              variant="rectangular"
                              width={60}
                              height={24}
                              sx={{ borderRadius: "12px" }}
                            />
                          </Box>
                        </Stack>
                      </CardContent>
                    </Card>
                  ))}
                </Stack>
              </Fade>
            ) : (
              <Stack spacing={3}>
                {studies.map((study) => (
                  <Card
                    key={study.id}
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                      border: "1px solid rgba(226, 232, 240, 0.6)",
                      background: "rgba(255, 255, 255, 0.9)",
                      backdropFilter: "blur(10px)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => handleStudySelect(study.id)}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Stack spacing={2}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: 2,
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                mb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  p: 1.5,
                                  borderRadius: "12px",
                                  background: `linear-gradient(135deg, ${primaryColor} 0%, #2563eb 100%)`,
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Science sx={{ fontSize: "20px" }} />
                              </Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  color: "#0f172a",
                                  fontSize: { xs: "16px", sm: "18px" },
                                }}
                              >
                                {study.name}
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#64748b",
                                fontSize: "14px",
                                lineHeight: 1.5,
                                mb: 2,
                              }}
                            >
                              {study.description}
                            </Typography>
                            {/* <Box
                              sx={{
                                display: "flex",
                                gap: 3,
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#64748b",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <School
                                  sx={{ fontSize: "14px", color: "#0ea5e9" }}
                                />
                                {study.participantCount} participants
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#64748b",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <AccessTime
                                  sx={{ fontSize: "14px", color: "#8b5cf6" }}
                                />
                                {study.duration}
                              </Typography>
                            </Box> */}
                          </Box>
                          <Chip
                            label="Active"
                            size="small"
                            sx={{
                              backgroundColor: "rgba(29, 78, 216, 0.1)",
                              color: "#1d4ed8",
                              fontSize: "11px",
                              fontWeight: 600,
                              border: "1px solid rgba(29, 78, 216, 0.2)",
                            }}
                          />
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
              </Stack>
            )}
          </Box>
        ) : (
          /* Survey Display Mode */
          <Box>
            {/* Study Info Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
                p: 2,
                borderRadius: "12px",
                background: "rgba(135, 46, 229, 0.05)",
                border: "1px solid rgba(135, 46, 229, 0.15)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Science sx={{ fontSize: "24px", color: "primary.main" }} />
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#0f172a",
                      fontSize: { xs: "16px", sm: "18px" },
                    }}
                  >
                    {getSelectedStudyInfo()?.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#64748b",
                      fontSize: "13px",
                    }}
                  >
                    {getSelectedStudyInfo()?.description}
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="outlined"
                size="small"
                onClick={handleBackToStudySelection}
                sx={{
                  borderColor: "primary.main",
                  color: "primary.main",
                  "&:hover": {
                    borderColor: "primary.main",
                    backgroundColor: "secondary.main",
                  },
                }}
              >
                Change Study
              </Button>
            </Box>

            {/* Modern Tabs */}
            <TabContainerV2>
              <StyledTabsV2 value={activeTab} onChange={handleTabChange}>
                <StyledTabV2
                  label="All Surveys"
                  icon={<AllInclusive sx={{ fontSize: "18px" }} />}
                  count={getTabCounts().all}
                  countColor="primary.main"
                  countBgColor="secondary.main"
                />
                <StyledTabV2
                  label="Not Started"
                  icon={<PlayArrow sx={{ fontSize: "18px" }} />}
                  count={getTabCounts().notStarted}
                  countColor="#64748b"
                  countBgColor="rgba(100, 116, 139, 0.1)"
                />
                <StyledTabV2
                  label="In Progress"
                  icon={<PendingActions sx={{ fontSize: "18px" }} />}
                  count={getTabCounts().inProgress}
                  countColor="#d97706"
                  countBgColor="rgba(217, 119, 6, 0.1)"
                />
                <StyledTabV2
                  label="Completed"
                  icon={<CheckCircle sx={{ fontSize: "18px" }} />}
                  count={getTabCounts().completed}
                  countColor="#059669"
                  countBgColor="rgba(5, 150, 105, 0.1)"
                />
              </StyledTabsV2>
            </TabContainerV2>
          </Box>
        )}
      </Box>

      {/* Loading State */}
      {!studySelectionMode && loading && (
        <Fade in={loading}>
          <Stack spacing={2.5}>
            {[1, 2, 3].map((index) => (
              <Card
                key={index}
                sx={{
                  borderRadius: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  border: "1px solid rgba(226, 232, 240, 0.6)",
                  background: "rgba(255, 255, 255, 0.9)",
                }}
              >
                <CardContent sx={{ p: 2.5 }}>
                  <Stack spacing={2}>
                    {/* Header Row Skeleton */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 2,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mb: 1,
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            width={48}
                            height={48}
                            sx={{ borderRadius: "12px" }}
                          />
                          <Skeleton
                            variant="text"
                            width="60%"
                            height={24}
                            sx={{ borderRadius: "4px" }}
                          />
                        </Box>
                        <Skeleton
                          variant="text"
                          width="80%"
                          height={16}
                          sx={{ borderRadius: "4px", mb: 1 }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            gap: 2,
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          <Skeleton
                            variant="text"
                            width={80}
                            height={16}
                            sx={{ borderRadius: "4px" }}
                          />
                          <Skeleton
                            variant="text"
                            width={100}
                            height={16}
                            sx={{ borderRadius: "4px" }}
                          />
                        </Box>
                      </Box>
                      <Skeleton
                        variant="rectangular"
                        width={80}
                        height={32}
                        sx={{ borderRadius: "20px" }}
                      />
                    </Box>

                    {/* Bottom Section Skeleton */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 1,
                      }}
                    >
                      <Skeleton
                        variant="text"
                        width={120}
                        height={14}
                        sx={{ borderRadius: "4px" }}
                      />
                      <Skeleton
                        variant="rectangular"
                        width={100}
                        height={36}
                        sx={{ borderRadius: "12px" }}
                      />
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Fade>
      )}

      {/* Survey Cards */}
      {!studySelectionMode && !loading && (
        <Fade in={!loading} timeout={600}>
          <Box>
            {getFilteredSurveys().length > 0 ? (
              <Stack
                spacing={2.5}
                sx={{
                  "& > *": {
                    width: "100%",
                  },
                }}
              >
                {getFilteredSurveys()?.map((item: any, index: number) => (
                  <Card
                    key={item.id}
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                      border: "1px solid rgba(226, 232, 240, 0.6)",
                      background: "rgba(255, 255, 255, 0.9)",
                      backdropFilter: "blur(10px)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <CardContent sx={{ p: 2.5 }}>
                      <Stack spacing={2}>
                        {/* Header Row */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: 2,
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                mb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  p: 1.5,
                                  borderRadius: "12px",
                                  background: `linear-gradient(135deg, ${
                                    primaryColor || "#16a34a"
                                  } 0%, #2563eb 100%)`,
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Assignment sx={{ fontSize: "20px" }} />
                              </Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  color: "#0f172a",
                                  fontSize: { xs: "16px", sm: "18px" },
                                }}
                              >
                                {item?.name || "Untitled Survey"}
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#64748b",
                                fontSize: "14px",
                                lineHeight: 1.5,
                                mb: 1,
                              }}
                            >
                              {item?.description ||
                                "Study-specific survey for research data collection"}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 2,
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#64748b",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <AccessTime
                                  sx={{ fontSize: "14px", color: "#0ea5e9" }}
                                />
                                {item?.estimatedTime || "15-20 min"}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#64748b",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Quiz
                                  sx={{ fontSize: "14px", color: "#8b5cf6" }}
                                />
                                {item?.totalQuestions || "30"} questions
                              </Typography>
                              {item?.status === "completed" &&
                                item?.completedDate && (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#059669",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <CheckCircleOutline
                                      sx={{
                                        fontSize: "14px",
                                        color: "#10b981",
                                      }}
                                    />
                                    Completed{" "}
                                    {new Date(
                                      item.completedDate
                                    ).toLocaleDateString()}
                                  </Typography>
                                )}
                            </Box>
                          </Box>
                          <Chip
                            icon={getStatusIcon(item?.status)}
                            label={statusLabelMap[item?.status] || "Unknown"}
                            sx={{
                              borderRadius: "20px",
                              px: 2,
                              py: 0.5,
                              fontSize: "12px",
                              fontWeight: 600,
                              color: statusTextColorMap[item?.status],
                              bgcolor: statusBgColorMap[item?.status],
                              border: `1px solid ${getStatusColor(
                                item?.status
                              )}20`,
                              "& .MuiChip-icon": {
                                fontSize: "16px",
                                color: statusTextColorMap[item?.status],
                              },
                            }}
                          />
                        </Box>

                        {/* Bottom Section */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            pt: 1,
                          }}
                        >
                          {/* Left side - Last Updated */}
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#94a3b8",
                              fontSize: "11px",
                              fontWeight: 500,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <Update sx={{ fontSize: "12px" }} />
                            Updated{" "}
                            {new Date(
                              item?.lastUpdated || new Date()
                            ).toLocaleDateString()}
                          </Typography>
                          <Button
                            variant="contained"
                            onClick={() => navigateToSurvey(item.id)}
                            color={
                              item?.status === "completed"
                                ? "success"
                                : "primary"
                            }
                          >
                            {item?.status === "completed"
                              ? "View Results"
                              : "Start Survey"}
                          </Button>
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
              </Stack>
            ) : (
              /* Empty State for Tab */
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  textAlign: "center",
                  p: 4,
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                    mb: 3,
                  }}
                >
                  {activeTab === 0 && (
                    <Assignment sx={{ fontSize: "48px", color: "#16a34a" }} />
                  )}
                  {activeTab === 1 && (
                    <PlayArrow sx={{ fontSize: "48px", color: "#64748b" }} />
                  )}
                  {activeTab === 2 && (
                    <PendingActions
                      sx={{ fontSize: "48px", color: "#d97706" }}
                    />
                  )}
                  {activeTab === 3 && (
                    <CheckCircle sx={{ fontSize: "48px", color: "#059669" }} />
                  )}
                </Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: "#64748b",
                    mb: 2,
                    fontSize: { xs: "20px", sm: "24px" },
                  }}
                >
                  {activeTab === 0 && "No Surveys Available"}
                  {activeTab === 1 && "No Surveys Not Started"}
                  {activeTab === 2 && "No Surveys In Progress"}
                  {activeTab === 3 && "No Surveys Completed"}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#64748b",
                    maxWidth: "400px",
                    lineHeight: 1.6,
                  }}
                >
                  {activeTab === 0 &&
                    "This study doesn't have any surveys available yet. Check back later for updates."}
                  {activeTab === 1 &&
                    "You have no surveys that haven't been started yet for this study."}
                  {activeTab === 2 &&
                    "You have no surveys currently in progress for this study."}
                  {activeTab === 3 &&
                    "You haven't completed any surveys for this study yet."}
                </Typography>
              </Box>
            )}
          </Box>
        </Fade>
      )}
    </Box>
  );
};

export default StudySurvey;
